import { Directive, ElementRef, Output, EventEmitter, HostListener, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[viewed]',
    standalone: true
})
export class ViewedDirective implements AfterViewInit {

	@Output() updateMsgStatus: EventEmitter<Array<number>> = new EventEmitter<Array<number>>();
	@Output() updateUserNotification: EventEmitter<void> = new EventEmitter<void>();
	@Output() hideScrollBtn: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(private el: ElementRef) {}

	ngAfterViewInit(): void {
		if (this.el.nativeElement.scrollHeight <= this.el.nativeElement.clientHeight) {
			setTimeout(() => {
				this.hideScrollBtn.emit(true);
			}, 300);
		}
	}

	@HostListener('scroll') scrolling() {
		let height: number = 0;
		const ids: Array<number> = [];

		if (this.el.nativeElement.scrollTop + this.el.nativeElement.clientHeight == this.el.nativeElement.scrollHeight) {
			this.updateUserNotification.emit();
		}
		if (this.el.nativeElement.scrollTop + 100 >= this.el.nativeElement.scrollHeight - this.el.nativeElement.clientHeight) {
			this.hideScrollBtn.emit(true);
		} else {
			this.hideScrollBtn.emit(false);
		}

		for (let childContainer of this.el.nativeElement.children) {
			for (let child of childContainer.children) {

				height += child.scrollHeight;

				if (height <= (this.el.nativeElement.scrollTop + this.el.nativeElement.clientHeight) && height >= this.el.nativeElement.scrollTop) {
					ids.push(child.id);
				}
			}
		}

		this.updateMsgStatus.emit(ids.filter(item => item));
	}
}